module.exports = __webpack_public_path__ + "static/media/Bharat Ji Elevation.e8fb1bab.jpg";